import React, { useState } from 'react';

const BulkEditModal = ({ isOpen, onClose, count, onSave }) => {
  const [reminderDaysBefore, setReminderDaysBefore] = useState('');
  const [active, setActive] = useState('');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  const updates = {};
  if (reminderDaysBefore !== '') {
    const n = parseInt(reminderDaysBefore, 10);
    if (!isNaN(n) && n >= 0 && n <= 30) updates.reminderDaysBefore = n;
  }
  if (active === 'true') updates.active = true;
  if (active === 'false') updates.active = false;
  if (notes !== '') updates.notes = notes;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(updates).length === 0) return;
    setSaving(true);
    try {
      await onSave(updates);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl max-w-md w-full overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">Bulk Edit</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Update {count} subscription{count !== 1 ? 's' : ''}. Leave a field empty to keep current value.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Remind (days before renewal)
            </label>
            <input
              type="number"
              min={0}
              max={30}
              value={reminderDaysBefore}
              onChange={(e) => setReminderDaysBefore(e.target.value)}
              placeholder="Leave empty to keep"
              className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Active
            </label>
            <select
              value={active}
              onChange={(e) => setActive(e.target.value)}
              className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Leave unchanged</option>
              <option value="true">Yes (active)</option>
              <option value="false">No (inactive)</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Notes
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Leave empty to keep"
              rows={2}
              className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 resize-none"
            />
          </div>
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2.5 bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg font-medium hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={Object.keys(updates).length === 0 || saving}
              className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {saving ? 'Saving...' : 'Apply to selected'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkEditModal;
